export default __webpack_public_path__ + "static/media/vip7.055b41ab.webp";